/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Managelpspecificndas4Inputs */

const en_coinvestments_managelpspecificndas4 = /** @type {(inputs: Coinvestments_Managelpspecificndas4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage Organisation-Specific NDAs`)
};

/**
* | output |
* | --- |
* | "Manage Organisation-Specific NDAs" |
*
* @param {Coinvestments_Managelpspecificndas4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_managelpspecificndas4 = /** @type {((inputs?: Coinvestments_Managelpspecificndas4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Managelpspecificndas4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_managelpspecificndas4(inputs)
});
export { coinvestments_managelpspecificndas4 as "coInvestments_manageLpSpecificNdas" }